// src/activities/cape-vr/cape-vr-views/cape-vr-files/cape-vr-form-files/CAPEVrProtocolLink.jsx

import { useState } from 'react';
import CAPEVrProtocolModal from '../../../../../components/modals/app-modals/CAPEVrProtocolModal';
import { useTranslation } from 'react-i18next';

function CAPEVrProtocolLink() {
  const { t } = useTranslation();
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
        <button type="button" onClick={() => setModalOpen(true)} className="app-btn-link">
            {t('cape_vr_protocol')}
        </button>
      </div>
      <CAPEVrProtocolModal
        isOpen={isModalOpen}
        onRequestClose={() => setModalOpen(false)}
      />
    </>
  );
}

export default CAPEVrProtocolLink; 